import * as BoxType from '@/services/rest-api/lib/delivery/box-type'

const defaultFieldOpts = {
  editable: true,
  isSortable: true,
}

const productCategoryFields = [
  {
    ...defaultFieldOpts,
    name: 'name',
    key: 'name',
    label: 'setting.list.product.field.productCategory',
    placeholder: 'setting.list.product.placeholder.productCategory',
    validation: 'required|max:255,length',
    type: 'text',
    'validation-messages': {
      max: 'Nama kategori produk tidak lebih dari 255 karakter',
    },    
    thAttr: {
      style: 'width:300px;'
    }
  },
  {
    editable: true,
    isSortable: false,
    name: 'box_type_ids',
    key: 'box_type_ids',
    fullObjectKey: 'box_types',
    type: 'select-resourceful-v3',
    label: 'setting.list.product.field.boxType',
    placeholder: 'setting.list.product.field.boxType',
    optionsGetter: BoxType.get,
    optionLabelFn: ({ item }) => item.name,
    trackBy: 'id',
    selectedLabel: 'name',
    formatter: (value) => value ?? '-',
    multiple: true,
    taggable: true,
    visibleTagCount: 3,
    customColumn: true,
    thAttr: {
      style: 'min-width:350px;'
    }
  },
  {
    ...defaultFieldOpts,
    name: 'min_temperature',
    key: 'min_temperature',
    label: 'setting.list.product.field.minTemperature',
    placeholder: 'setting.list.product.placeholder.minTemperature',
    validation: 'bail|number|min:-100,value|max:100,value',
    'validation-messages': {
      number: 'Minimum temperatur harus berupa angka',
      min: 'Minimum temperatur tidak kurang dari -100°C',
      max: 'Minimum temperatur tidak lebih dari 100°C',
    },
    // TECHDEBT: replace _type with casting function or better solution to cast input to proper type
    _type: 'number',
    step: 0.1,
    formatter: (value) => value ?? '-',
  },
  {
    ...defaultFieldOpts,
    name: 'max_temperature',
    key: 'max_temperature',
    label: 'setting.list.product.field.maxTemperature',
    placeholder: 'setting.list.product.placeholder.maxTemperature',
    validation: 'bail|number|min:-100,value|max:100,value',
    'validation-messages': {
      number: 'Maksimum temperatur harus berupa angka',
      min: 'Maksimum temperatur tidak kurang dari -100°C',
      max: 'Maksimum temperatur tidak lebih dari 100°C',
    },
    _type: 'number',
    step: 0.1,
    formatter: (value) => value ?? '-',
  },
]

export default productCategoryFields
